import React from 'react';
import { ArrowDownIcon, NotificationDot } from './NavigationIcons';

interface DropdownTriggerProps {
	label: string;
	isActive?: boolean;
	isMobile?: boolean;
	onClick?: (e: React.MouseEvent) => void;
	className?: string;
	href?: string;
}

const DropdownTrigger: React.FC<DropdownTriggerProps> = ({
	label,
	isActive = false,
	isMobile = false,
	onClick,
	className = '',
	href
}) => {
	const baseClass = isMobile 
		? 'c-mobile-navigation__menu-link u-bold-04 has-tag js-expander-trigger'
		: `c-navigation__menu-link u-bold-10 has-tag js-navigation-menu-trigger${isActive ? ' is-open' : ''}`;

	const finalClassName = `${baseClass} ${className}`.trim();

	return (
		<a
			href={href || "#"}
			className={finalClassName}
			onClick={onClick}
		>
			{isMobile ? (
				<>
					{label}
					<NotificationDot />
					<span>
						<ArrowDownIcon />
					</span>
				</>
			) : (
				<>
					<span className="c-navigation__menu-link-label">
						{label}
					</span>
					<NotificationDot />
					<span>
						<ArrowDownIcon />
					</span>
				</>
			)}
		</a>
	);
};

export default DropdownTrigger; 